// Edit this file to make the site yours.
// To add a real screenshot to a project, drop the image in `public/projects/`
// and set `image: "projects/your-file.png"`. If `image` is omitted, a styled
// gradient placeholder is shown instead.

export const projects = [
  {
    title: "FibiSpace",
    description:
      "The company portfolio website — a polished, responsive showcase built end to end with a React front end and a Node/Express + PostgreSQL back end.",
    tech: ["React", "Express", "Node.js", "PostgreSQL", "Tailwind"],
    // image: "projects/fibispace.png",
    link: "https://fibispace.com",
    accent: "#22d3ee",
  },
  {
    title: "The Inn Dhangadhi",
    description:
      "A hotel portfolio website with room showcases and booking-focused pages, built on Next.js with an Express + PostgreSQL back end.",
    tech: ["Next.js", "React", "Express", "Node.js", "PostgreSQL", "Tailwind"],
    // image: "projects/theinn.png",
    link: "https://theinndhangadhi.com",
    accent: "#a855f7",
  },
  {
    title: "Daily Dose",
    description:
      "An e-commerce platform for cosmetic products — clean storefront and checkout, powered by Next.js with Redis caching for a fast experience.",
    tech: [
      "Next.js",
      "React",
      "Express",
      "Node.js",
      "PostgreSQL",
      "Redis",
      "Tailwind",
    ],
    // image: "projects/dailydose.png",
    link: "https://dailydose.com",
    accent: "#38bdf8",
  },
  {
    title: "361 Gadgets",
    description:
      "A multi-vendor e-commerce platform for electronic gadgets, with vendor management and a scalable Next.js + Redis-backed architecture.",
    tech: [
      "Next.js",
      "React",
      "Express",
      "Node.js",
      "PostgreSQL",
      "Redis",
      "Tailwind",
    ],
    // image: "projects/361gadgets.png",
    link: "https://361gadgets.com",
    accent: "#f472b6",
  },
];

export const skills = [
  "Next.js",
  "React",
  "Express",
  "Node.js",
  "TypeScript",
  "JavaScript",
  "Redux",
  "MongoDB",
  "PostgreSQL",
  "REST APIs",
  "Tailwind CSS",
  "Git & CI/CD",
];
